// extracted by mini-css-extract-plugin
export default {"shape":"Stats_shape__WWF7+","item":"Stats_item__ogg8g","gridItem":"Stats_gridItem__BgQ9K"};